// Shell panelu admina (TF.5): sidebar (lewo, fixed) + Topbar + content (scrollable).
// Callpage-ref: components/Layout.tsx — esencja bez TabBar/TabPanels/CompanySwitcher/Notifications.
import type { ReactNode } from 'react';

import { useInTabShell } from '@/components/tabs/tab-shell';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

interface LayoutProps {
  children: ReactNode;
  title?: string;
}

export function Layout({ children, title }: LayoutProps) {
  const inTabShell = useInTabShell();

  // W powłoce kart (AdminShell) chrome — Sidebar/Topbar/pasek kart — rysuje się RAZ na
  // zewnątrz, a panel karty przewija treść. Tu renderujemy więc tylko `<main>` (bez własnego
  // Sidebara/Topbara/scrolla), żeby nie dublować chrome per karta.
  if (inTabShell) {
    return <main className="min-w-0">{children}</main>;
  }

  return (
    <div className="flex min-h-screen bg-bg-secondary">
      <Sidebar />
      <div className="flex flex-1 flex-col min-w-0">
        <Topbar title={title} />
        <main className="flex-1 min-w-0 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}
